const featureToggles = {
  savedJobs: true,
  uploadCV: true,
  creatorPartnership: true,
};

export default featureToggles;
